import { ActionTypes } from "../constants";

const reduceNotifications = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_NOTIFICATIONS_SUCCESS:
            return action.data.map((data) => ({...data, folder: action.folder}));

        case ActionTypes.GET_NOTIFICATION_SUCCESS:
            return [
                ...(state || []).filter(({id}) => id !== action.data.id),
                action.data
            ];

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export const getNotification = (notifications, notificationId) => !notifications ? null :  notifications.find(({id}) => id === notificationId);

export default reduceNotifications;
